import { render, staticRenderFns } from "./registration-info.vue?vue&type=template&id=0bc48f3e&scoped=true&"
import script from "./registration-info.vue?vue&type=script&lang=js&"
export * from "./registration-info.vue?vue&type=script&lang=js&"
import style0 from "./registration-info.vue?vue&type=style&index=0&id=0bc48f3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc48f3e",
  null
  
)

export default component.exports